import { FC } from "react";

import { BotAvatar } from "./BotAvatar";
import { ChatbotClassMap } from "../types";

interface Props {
  readonly styles: ChatbotClassMap;
}

/** Animated 3-dot indicator shown while an assistant reply is in flight. */
export const BusyIndicator: FC<Props> = ({ styles }) => (
  <div className={styles.BusyIndicator}>
    <BotAvatar styles={styles} />
    <div className={styles.BusyIndicatorDots} role="status" aria-label="Thinking">
      <svg
        className={styles.BusyIndicatorDotsVisual}
        width="26"
        height="20"
        viewBox="0 0 26 20"
        fill="none"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="3" cy="10" r="3" />
        <circle cx="13" cy="10" r="3" />
        <circle cx="23" cy="10" r="3" />
      </svg>
    </div>
  </div>
);
